import * as ActionTypes from '../actions/SocialPayActions';
import deepmerge from 'deepmerge';

const initialState = {
  loading: {},
};

export function socialPay (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.HANDLE_SET_LOADING_SOCIAL_PAY_PLATFORM: {
      const { selectedSocialPayPlatform } = action.payload;
      return deepmerge(state, { loading: {
        [selectedSocialPayPlatform]: true,
      } });
    }

    case ActionTypes.HANDLE_REMOVE_LOADING_SOCIAL_PAY_PLATFORM: {
      const { selectedSocialPayPlatform } = action.payload;
      return deepmerge(state, { loading: {
        [selectedSocialPayPlatform]: null,
      } });
    }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/SocialPayReducers.js